import { useFeatureFlag } from '@/services/feature/useFeatureQueries'
import { SHIPPER_COMPANY_ID_SPECIAL_CHARS_FLAG } from '@/services/shipper/types'

/**
 * 업체아이디 특수문자 허용 여부. 화주 유형별 폼 훅이 zod 스키마를 고를 때 쓴다.
 *
 * 화주사 목록 화면(ShipperPage)에서 같은 키를 미리 조회해 두므로, 모달이 열릴 때는
 * react-query 캐시에서 바로 값이 나온다. 캐시가 비어 있어도 기본값이 false 라 종전 규칙으로 시작한다.
 */
export const useCompanyIdSpecialChars = (): boolean => {
  const { data } = useFeatureFlag(SHIPPER_COMPANY_ID_SPECIAL_CHARS_FLAG)
  return data ?? false
}
